import { render, staticRenderFns } from "./Plugins.vue?vue&type=template&id=3359e3d7&"
import script from "./Plugins.vue?vue&type=script&lang=ts&"
export * from "./Plugins.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports